import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { useState } from 'react';
import { useEffect } from 'react';
import useAccounts from '../../hooks/useAccounts';
import { useGetCategoriesQuery } from '../../services/dashboardService';
import { FullPageWrapper } from '../custom/IndividualMappingLayout';
import amIVisible from '../../componentControl/registry';
import radioOptions from "./categoriesOptions.json"

export const IndividualCategoriesMapping = ({ formik }) => {

    const { t } = useTranslation()

    const [isLoadingAccounts, accountsList] = useAccounts('items');
    const [, paymentLiabilityList] = useAccounts('paymentLiability');

    const { currentSw, categoriesLabels } = useSelector(state => state.dashboard)

    const { categories, isParentCategory } = formik.values;

    const [parentCategory, setCategory] = useState(isParentCategory);

    const [isCategoryChanged, setChanged] = useState(false);

    const isDynamicMapping = amIVisible("enter field for product and categories individual")

    const [isEmptyLabels, setIfEmptyLabels] = useState(false)

    const { isLoading, isFetching, refetch } = useGetCategoriesQuery({
        recordItems: false,
        productLevel: false,
        superParentCategory: Number(parentCategory)
    }, {
        refetchOnMountOrArgChange: false,
        selectFromResult: ({ data, ...rest }) => {
            let labels = data?.map((item) => {
                return {
                    label: item.name,
                    value: item.id,
                    ...(item.type ? { type: item.type } : {}),
                }
            })

            labels = _.filter(labels, item => {
                return !_.keys(_.pickBy(categories, (items) => items !== '')).includes(item?.value + '')
            })

            return {
                data: labels,
                ...rest
            }
        }
    })

    useEffect(() => {
        setIfEmptyLabels(categoriesLabels?.length === 0)
    }, [categoriesLabels])

    useEffect(() => {
        if (categoriesLabels?.length === 0 && !isEmptyLabels) {
            refetch()
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categoriesLabels])

    useEffect(() => {
        if (isCategoryChanged) {
            setChanged(false)
            refetch()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCategoryChanged])

    const refresh = (value) => {
        setCategory(value)
        setChanged(true)
    }

    return (
        <>
            <FullPageWrapper
                title={t('Map Revenue Classes')}
                fullPageDesp={t(`Individual Revenue Classes can be mapped to unique accounts in ${currentSw}. All unassigned and new Revenue Classes will be assigned to the default revenue class account.`, { swName: currentSw })}
                formik={formik}
                formikFieldName={"categoriesMapping"}
                isLoading={isLoading || isFetching}
                isAccountsLoading={isLoadingAccounts}
                heading={"Revenue Classes"}
                parentCategory={parentCategory}
                isDynamicMapping={isDynamicMapping}
                options={accountsList}
                paymentLiabilityList={paymentLiabilityList}
                labelOption={categoriesLabels}
                refetch={refresh}
                radioOptions={radioOptions}
                advanceMapping
                rowLoaderProps={{
                    box: true,
                    rows: 10
                }}
            />
        </>
    )
}